export default __webpack_public_path__ + "static/the-gables-homepage-loop-video-9037238408147702ec591c18d3991f5b.webm";